import { Icon } from '@chakra-ui/react';

export const Anonymous = (props) => (
  <Icon viewBox="0 0 20 20" boxSize="16px" color="icon.g1" {...props}>
    <path
      d="M7.00016 10.6772C5.71545 10.6772 4.66683 11.7422 4.66683 13.0469C4.66683 14.3517 5.71545 15.4167 7.00016 15.4167C8.17164 15.4167 9.14595 14.5309 9.30876 13.3855H10.6916C10.8544 14.5309 11.8287 15.4167 13.0002 15.4167C14.2849 15.4167 15.3335 14.3517 15.3335 13.0469C15.3335 11.7422 14.2849 10.6772 13.0002 10.6772C11.8287 10.6772 10.8544 11.563 10.6916 12.7084H9.30876C9.14595 11.563 8.17164 10.6772 7.00016 10.6772Z"
      fill="#666666"
    />
    <path
      d="M7.16292 4.58348C6.49534 4.57554 5.86993 5.02632 5.68896 5.71679L4.74495 9.32302H3.66683C3.48273 9.32302 3.3335 9.47458 3.3335 9.66155C3.3335 9.84852 3.48273 10.0001 3.66683 10.0001C7.88905 10.0001 12.1113 10.0001 16.3335 10.0001C16.5176 10.0001 16.6668 9.84852 16.6668 9.66155C16.6668 9.47458 16.5176 9.32302 16.3335 9.32302H15.2554L14.3114 5.71679C14.0886 4.86698 13.1933 4.38123 12.3739 4.66547L10.1082 5.45098C10.0383 5.47526 9.96207 5.47526 9.89209 5.45098L7.62646 4.66547C7.47281 4.61217 7.31698 4.58531 7.16292 4.58348Z"
      fill="#666666"
    />
  </Icon>
);
